export default __webpack_public_path__ + "static/media/nodejs.ea853092.png";